import axios from 'axios';
import { API_BASE_URL } from '@/constants';
import { useInfiniteQuery } from '@tanstack/react-query';

export const useFetchSolvedCases = () => {
  const fetchPets = async ({
    pageParam = 1,
  }): Promise<{ results: Array<Pet>; next: string | null }> => {
    const response = await axios.get(`${API_BASE_URL}/pets/`, {
      params: {
        is_active: true,
        solved_case: true,
        page: pageParam,
        ordering: '-solved_at',
      },
    });
    return response.data;
  };

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['pets-solved-cases'],
    queryFn: fetchPets,
    initialPageParam: 1,
    getNextPageParam: (lastPage: { results: Array<Pet>; next: string | null }) => {
      const nextPageUrl = lastPage.next;
      if (!nextPageUrl) return undefined;
      const urlParams = new URLSearchParams(nextPageUrl.split('?')[1]);
      if (!urlParams.has('page')) return undefined;
      const page = urlParams.get('page');
      if (!page) return undefined;
      if (isNaN(Number(page))) return undefined;
      return Number(page);
    },
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
